export default __webpack_public_path__ + "icon_direction.a0e48d630e3a9ec3babe4cd1c3e306fb.svg";